import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import { Link, withRouter, BrowserRouter as Router, NavLink as RouterNavLink  } from "react-router-dom"

import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { map, stubTrue } from "lodash"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import axios from 'axios';
import { addNewActivity, postActivityFilter,postActivityOverviewFilter, changeActivityStatus, searchActivityFilter, deleteMainActivity, updateMainActivity, getSellerShowingDetail, getBuyerShowingDetail, getOpenhouseShowingDetail, getProjectInviteDetail } from "../../store/actions"
import DeleteModal from "../../components/Common/DeleteModal";
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; 
import 'react-date-range/dist/theme/default.css';
import RsAdNew from "components/buttons/Adnew";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  Nav,
  NavItem,
  NavLink,
  FormGroup,
  Label,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  CardHeader,
} from "reactstrap"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//i18n
import { withTranslation } from "react-i18next"
import Moment from "react-moment";
import moment from 'moment';
import SaveButton from "components/buttons/save";
import Select from "react-select"
import { API_URL } from "helpers/app_url";
import RsAdNewV2 from "components/buttons/Adnew-v2";
import TimePicker from "components/dropdowns/Timepicker";
import { truncate } from "lodash";
import PhoneInputField from "components/dropdowns/PhoneInputField";
import SafeField from "helpers/SafeField";
import { hasPermission } from "helpers/checkPermission";
class Activity extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'All',
      activePeriod: 'Today',
      isSearch: false,
      isLoading: false,
      activity: '',
      showFlatpickr: false,
      selectedMulti2: null,
      optionGroup1:[],
      dateRange: [new Date(), moment().add(1, 'day').toDate()]
    }
    this.toggleAddNew = this.toggleAddNew.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.toggleSellerShowing = this.toggleSellerShowing.bind(this);
    this.toggleOpenhouseShowing = this.toggleOpenhouseShowing.bind(this);
    this.toggleBuyerShowing = this.toggleBuyerShowing.bind(this)
    this.toggleEventShowing = this.toggleEventShowing.bind(this)
    this.onClickDelete = this.onClickDelete.bind(this);
    this.searchCanavas = this.searchCanavas.bind(this);
    this.searchSubmit = this.searchSubmit.bind(this);
  }
  getUserType = (type) => {
    if(type==3)
      return 'Lead';
    else if(type==2)
    return 'Client';
    
  }
  searchCanavas () {
    this.setState({ isSearchFrm: !this.state.isSearchFrm });
  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
        deleteModal: !prevState.deleteModal,
    }));
};
onClickDelete = (activity) => {
    this.setState({ activity: activity });
    this.setState({ deleteModal: true });
};


convertISOTo12Hour = (isoString) => {
  const date = new Date(isoString);
  let hours = date.getHours();
  const originalMinutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  const roundedMinutes = Math.round(originalMinutes / 15) * 15;
  const minutes = roundedMinutes % 60;
  if (roundedMinutes === 60) {
    hours = (hours % 12) + 1;
    if (hours === 12) {
      ampm = ampm === 'AM' ? 'PM' : 'AM';
    }
  }

  const formattedMinutes = minutes.toString().padStart(2, '0');
  const minInt = parseInt(formattedMinutes)
  return { hours, minInt, ampm };
};
handleDeleteActivity = () => {
    const { onDeleteActivity } = this.props;
    const { activity } = this.state;

    if (activity.id !== undefined) {
        onDeleteActivity(activity);
        this.setState({ deleteModal: false });
    }
};
  
  sellerShowingToggle() {
    this.setState(prevState => ({
        isSellerShowing: !prevState.isSellerShowing
    }));
  }
 
  toggleSellerShowing = arg => {
    const activity = arg;
    const {  onGetSellerShowingDetail } = this.props;
    if(activity.id > 0 ){
        onGetSellerShowingDetail(activity.id);
    }
  
    this.sellerShowingToggle();
  };

  buyerShowingToggle() {
    this.setState(prevState => ({
        isBuyerShowing: !prevState.isBuyerShowing
    }));
  }
  toggleBuyerShowing = arg => {
    const activity = arg;
    const {  onGetBuyerShowingDetail } = this.props;
     if(activity.id > 0 ){
        onGetBuyerShowingDetail(activity.id);
     }
    this.buyerShowingToggle();
  };

  eventShowingToggle() {
    this.setState(prevState => ({
        isEventShowing: !prevState.isEventShowing
    }));
  }
  toggleEventShowing = arg => {
    const activity = arg;
    const {  onGetProjectInviteDetail } = this.props;
     if(activity.id > 0 ){
        onGetProjectInviteDetail(activity.id);
     }
    this.eventShowingToggle();
  };

  openhouseShowingToggle() {
    this.setState(prevState => ({
        isOpenhouseShowing: !prevState.isOpenhouseShowing
    }));
  }
  toggleOpenhouseShowing = arg => {
    const activity = arg;
    const {  onGetOpenhouseShowingDetail } = this.props;
    if(activity.id > 0 ){
       onGetOpenhouseShowingDetail(activity.id);
    }
   
    this.openhouseShowingToggle();
  };

toggleEdit() {
  this.setState({ activity: "", isEdit: false, iseditOpen: !this.state.iseditOpen });
  this.editToggle();
}
editToggle() {
  this.setState(prevState => ({
      iseditOpen: !prevState.iseditOpen
  }));
}
toggleEdit = arg => {
  const activity = arg;
  this.setState({
    activity: {
            id: activity.id,
            activityId: activity.activityId,
            agentId: activity.agentId,
            title: activity.title,
            contactName: activity.contactName,
            contactPhone: activity.contactPhone,
            contactEmail: activity.contactEmail,
            activityStartDate: activity.activityStartDate,
            startTime: activity.startTime,
            endTime: activity.endTime,
            activityType: activity.activityType,
            activityStatus: activity.activityStatus,
            activityRefId: activity.activityRefId,
            activityDescription: activity.activityDescription,
            activityDetails:activity.activityDetails,
            activityLocationType: activity.activityLocationType,
            activityLocation: activity.activityLocation,
            activityLatitude: activity.activityLatitude,
            activityLongitude: activity.activityLongitude,
            isActive: activity.isActive
      },
      isEdit: true,
  });
  this.editToggle();
};
  handleChangeStatus = (activity, newStatus) => {
    this.setState({
      updateActivity: {
        id: activity.id,
        activityId: activity.activityId,
        agentId: parseInt(activity.agentId),
        title: activity.title,
        contactName: activity.contactName,
        contactPhone: activity.contactPhone,
        contactEmail: activity.contactEmail,
        activityStartDate: activity.activityStartDate,
        startTime: activity.startTime,
        endTime: activity.endTime,
        activityType: parseInt(activity.activityType),
        activityStatus: newStatus,
        activityRefId: activity.activityRefId,
        activityDescription: activity.activityDescription,
        activityLocationType: parseInt(activity.activityLocationType),
        activityLocation: activity.activityLocation,
        activityLatitude: activity.activityLatitude ? activity.activityLatitude : null,
        activityLongitude: activity.activityLongitude ? activity.activityLongitude : null,
        isActive: activity.isActive
      }
    }, () => {
      this.props.changeActivityStatus(this.state.updateActivity)
    });
  };
  handleStartTime = (setFieldValue, values) => {
    const { startHrs, startMin, startDif } = values;
    const hours = parseInt(startHrs, 10);
    const minutes = parseInt(startMin, 10);
    const meridiem = startDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const date = new Date();
    const formattedTime = moment()
      .set({ hour: meridiem, minute: minutes })
      .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    setFieldValue('startTime', formattedTime);

  };

  handleEndTime = (setFieldValue, values) => {
    const { endHrs, endMin, endDif } = values;
    const hours = parseInt(endHrs, 10);
    const minutes = parseInt(endMin, 10);
    const meridiem = endDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const date = new Date();
    const formattedTime = moment()
      .set({ hour: meridiem, minute: minutes })
      .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    setFieldValue('endTime', formattedTime);

  };
  
  toggleAddNew() {
    this.setState({ isAddNew: !this.state.isAddNew });
    
  }
  componentDidMount() {
    this.fetchData();

    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const agentId = parseInt(localStorage.getItem('userId'))
    const payload = {
      agentId: agentId
    };

    axios.post(`${API_URL}AgentExt/allreferrals`, payload, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
          const options = res.data.map((item) => ({
                value: item.id,
                label: item.firstName + ' ' + item.lastName +'-'+ this.getUserType(item.referralTypeId)+' , '+ item.email,
              }));
          
              this.setState({ optionGroup1: options, isLoading: false });


        //const clients = res.data;
        //this.setState({ clients });
      })
  }
  handleSelect = (tab) => {
    this.setState({ activeTab: tab, isLoading: true }, this.fetchData);
  };
  handlePeriodSelect = (period) => {
    if (period === 'Select Period') {
      this.setState({ showFlatpickr: true });
    } else {
      this.setState({ activePeriod: period, dateRange: [], isLoading: true, showFlatpickr: false }, this.fetchData);
    }
  };
  handleDateChange = (selectedDates) => {
    const { selection } = selectedDates;
    this.setState({
      dateRange: [selection.startDate, selection.endDate],
      activePeriod: 'Select Period',
      //activePeriod: `${moment(selection.startDate).format('DD/MM/YYYY')} - ${moment(selection.endDate).format('DD/MM/YYYY')}`,
      showFlatpickr: false,
      isLoading: true
    }, this.fetchData);
  };
  convertDateRange = (activityFromDate, activityToDate) => {
    const from = moment(activityFromDate).startOf('day');
    const to = moment(activityToDate).endOf('day');
    //
    return { from, to };
};

 getDateRange = (period, dateRange = [new Date(), new Date()]) => {
    const today = moment().startOf('day');
    switch (period) {
      case 'Today':
        return {
          from: today.clone().set({ hour: 0, minute: 0, second: 1 }),
          to: today.clone().set({ hour: 23, minute: 59, second: 59 })
        };
        case 'Overdue':
          //this.fetchOverDueData();
      case 'Tomorrow':
        const tomorrow = today.clone().add(1, 'days').startOf('day');
        //
        return {
          from: tomorrow,
          to: tomorrow
        };
      case 'This Week':
        const startOfThisWeek  = today.clone().startOf('week').set({ hour: 0, minute: 0, second: 1 });
        const endOfThisWeek  = today.clone().endOf('week').set({ hour: 23, minute: 59, second: 59 });
        return { from: startOfThisWeek, to: endOfThisWeek  };
        case 'Next Week':
          const startOfNextWeek = today.clone().add(1, 'week').startOf('week').set({ hour: 0, minute: 0, second: 1 });
          const endOfNextWeek = today.clone().add(1, 'week').endOf('week').set({ hour: 23, minute: 59, second: 59 });
          return { from: startOfNextWeek, to: endOfNextWeek };
      case 'Select Period':
      
      if (dateRange.length !== 2 || !moment(dateRange[0]).isValid() || !moment(dateRange[1]).isValid()) {
        throw new Error("dateRange must be an array with two valid dates [startDate, endDate]");
      }
        const [startDate, endDate] = dateRange;
        //

        return {
          from: moment(startDate).set({ hour: 0, minute: 0, second: 1 }),
          to: moment(endDate).set({ hour: 23, minute: 59, second: 59 })
        };
      default:
        
        return {
          from: today.clone().set({ hour: 0, minute: 0, second: 1 }),
          to: today.clone().set({ hour: 23, minute: 59, second: 59 })
        };
    }
};
 
  fetchData = () => {
    const { activeTab, activePeriod, dateRange   } = this.state;
    const activityTypeIdMap = {
      'All': 0,
      'Calls': 3,
      'Meetings': 1,
      'To-do': 2,
      'Emails': 4,
      'Client Events': 2,
      'Deadlines': 5,
      'Seller Showings': 6,
      'Buyer showing': 7,
      'Open house': 8,
      'Event Invites': 9,
      'Messages' : 12
    };

    const isAllSelected = activeTab === 'All';
    const activityTypeId = isAllSelected ? 0 : activityTypeIdMap[activeTab];
    const { from, to } = this.getDateRange(activePeriod, dateRange );
    const { from: convertedFrom, to: convertedTo } = this.convertDateRange(from, to);
    const requestData = {
      activityTypeId:Array.isArray(activityTypeId) ? activityTypeId : [activityTypeId],
      activityFromDate: moment(convertedFrom).format('YYYY-MM-DD'),
      activityToDate: moment(convertedTo).format('YYYY-MM-DD'),
      agentId: parseInt(localStorage.getItem("userId"))
    };

    this.setState({
      activityFromDate: convertedFrom,
      activityToDate: convertedTo
  });

    this.props.postActivityFilter(requestData)
   
  };

  fetchOverDueData = () => {
    this.setState({  activePeriod: 'Overdue' });
    const { activeTab } = this.state;
    const activityTypeIdMap = {
      'All': 0
    };
    const isAllSelected = activeTab === 'All';
    const activityTypeId = isAllSelected ? 0 : activityTypeIdMap[activeTab];
    const currentYear = moment().year();
    const from = moment(`${currentYear}-01-01`);
    const to = moment(`${currentYear}-06-28`);
    const { from: convertedFrom, to: convertedTo } = this.convertDateRange(from, to);
    const requestData = {
      activityTypeId: Array.isArray(activityTypeId) ? activityTypeId : [activityTypeId],
      activityFromDate: moment(convertedFrom).format('YYYY-MM-DD'),
      activityToDate: moment(convertedTo).format('YYYY-MM-DD'),
      agentId: parseInt(localStorage.getItem("userId"))
    };
    this.props.postActivityOverviewFilter(requestData);
};

  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;
        
        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        setFieldValue('activityLocation', place.formatted_address);
        setFieldValue('activityLatitude', longitude);
        setFieldValue('activityLongitude', latitude);
      })
      .catch(error => console.error('Error', error));
  };
  handleSubmit = (values, actions) => {
    const payload = {
      agentId : parseInt(values.agentId),
      title: values.title,
      contactName: values.contactName,
      contactPhone: values.contactPhone,
      contactEmail: values.contactEmail,
      activityStartDate: moment(values.activityStartDate).format('YYYY-MM-DD'),
      startTime: values.startTime,
      endTime: values.endTime,
      activityStatus:1,
      activityType: parseInt(values.activityType),
      activityRefId:values.activityRefId,
      activityDescription: values.activityDescription,
      activityLocationType: parseInt(values.activityLocationType),
      activityLocation:values.activityLocation,
      activityLatitude: values.activityLatitude ? values.activityLatitude : null,
      activityLongitude: values.activityLongitude ? values.activityLongitude : null,
      isActive: values.isActive
    };
    this.props.addNewActivity(payload, (status)=>{
      if(status==true){
          this.toggleAddNew();
      }
    })
    
  }
  searchSubmit(values){
    this.props.searchActivityFilter(values)
    this.searchCanavas();
    this.setState({activePeriod:'', isSearch: true})
  }
  handleCheckboxChange = async (values, setFieldValue) => {
    const updatedStatus = !values.markAsDone;
    setFieldValue("markAsDone", updatedStatus);
  
    const payload = {
      id: values.id,
      activityId: values.activityId,
      activityStatus: updatedStatus ? 3 : values.activityStatus, // Set status to 3 if checked
      activityType: parseInt(values.activityType),
      activityDescription: values.activityDescription,
      agentId: values.agentId,
    };
  
    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj.resultData.bearerToken;
      
      await axios.put(`${API_URL}LeadActivity/UpdateFilteredLeadActivityStatus`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
  
      
    } catch (error) {
      console.error("Error updating activity:", error);
    }
  };

 

  fetchUsers = () => {
    const authUser = localStorage.getItem("authUser");
    if (!authUser) return;
    const obj = JSON.parse(authUser);
    const token = obj?.resultData?.bearerToken;
    if (!token) return;
    const str = 'Bearer ' + token;
    axios.post(`${API_URL}Activity/userfilteredactivitiesbytype`, {
        params: { agentId: parseInt(localStorage.getItem("userId")) },
        headers: { Authorization: str }
    })
    .then(res => this.setState({ templates: res.data }))
    .catch(err => console.error("Error fetching templates:", err));
}
 getStatus = (status) => {
    if(status==1)
      return 'Available';
    else if(status==2)
    return 'Not Available';
  else if(status==3)
    return 'Sold';
  else if(status==4)
    return 'Sold Conditionally'  
  }
  render() {
    const { t, activities, onUpdateMainActivity, openhouseshowingdetail, sellershowingdetail, buyershowingdetail, inviteDetail } = this.props;
    const { activeTab, activePeriod, activity, showFlatpickr, dateRange , deleteModal, isEdit,  optionGroup1, isLoading, isSearch, activityFromDate, activityToDate   } = this.state;
    const initialStartTime = (activity.activityType === 1 ) ? this.convertISOTo12Hour( activity.startTime ) : '';
    const initialEndTime = (activity.activityType === 1 ) ? this.convertISOTo12Hour( activity.endTime ) : '';
    const userModule = localStorage.getItem('userModule');
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);

    //
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
          <ToastContainer autoClose={2000} />
          <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteActivity}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Activity | Realty Space</title>
          </MetaTags>
         
          <Container fluid className="">
           
             <Row className="project-header">
            <Col xl="7">
             <Breadcrumbs
              title={this.props.t("Activities")}
              breadcrumbItem={this.props.t("Activities")}
            />
            </Col>
            <Col xl="5">
            <div className="pt-2 float-end mt-2">
             {hasPermission("RealtorLeadsActivities", "Add") && (
            <RsAdNewV2 onClick={this.toggleAddNew}>Add New</RsAdNewV2>
              )}
            </div>
            </Col>
            </Row>
          
              <Row className="mt-20 mb-20">
                    <Col sm="9">
                <Router>
                <Nav className="projectTab actTabs ms-3" variant="tabs" style={{padding:10}}>
          <NavItem>
            <NavLink as={Link} to="#" active={activeTab === 'All'} onClick={() => this.handleSelect('All')}>
              <span className="d-none d-sm-block">{t("All")}</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink as={Link} to="#" active={activeTab === 'Calls'} onClick={() => this.handleSelect('Calls')}>
              <span className="d-none d-sm-block"><i className="bx bx-phone-call act-icon"></i> {t("Calls")}</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink as={Link} to="#" active={activeTab === 'Meetings'} onClick={() => this.handleSelect('Meetings')}>
              <span className="d-none d-sm-block"><i className="bx bx-calendar act-icon"></i> {t("Meetings")}</span>
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink as={Link} to="#" active={activeTab === 'Messages'} onClick={() => this.handleSelect('Messages')}>
              <span className="d-none d-sm-block"><i className=" bx bx-message-alt-dots act-icon"></i> {t("Messages")}</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink as={Link} to="#" active={activeTab === 'Emails'} onClick={() => this.handleSelect('Emails')}>
              <span className="d-none d-sm-block"><i className="bx bx-mail-send act-icon"></i> {t("Emails")}</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink as={Link} to="#" active={activeTab === 'To-do'} onClick={() => this.handleSelect('To-do')}>
              <span className="d-none d-sm-block"><i className="bx bx-notepad act-icon"></i> {t("Task")}</span>
            </NavLink>
          </NavItem>
         
        
          <NavItem>
            <NavLink as={Link} to="#" active={activeTab === 'Client Events'} onClick={() => this.handleSelect('Client Events')}>
              <span className="d-none d-sm-block"><i className="mdi mdi-sign-real-estate act-icon"></i> {t("Client Events")}</span>
            </NavLink>
          </NavItem>
        
        
                </Nav>
                </Router>
                </Col>
                <Col sm="3">
                <Nav className="product-view-nav float-end me-3" pills>
                        <NavItem>
                          <NavLink tag={RouterNavLink} to="/activity" activeClassName="active">
                          
                    
                            <i className="bx bx-grid-alt" />
                          </NavLink>
                        </NavItem>
                        <NavItem>
                        <NavLink tag={RouterNavLink} to="/calendar">
                            <i className=" bx bx-calendar" />
                          </NavLink>
                        </NavItem>

                        <NavItem>
                        <NavLink  onClick={this.searchCanavas}>
                            <i className="  bx bx-search" />
                          </NavLink>
                        </NavItem>
                      </Nav>
                </Col>
              </Row>
             
            <Card>
           
              <Row className="">
            
                <Col lg="5">
                <Router>
                <Nav tabs className="projectTab actTabs" style={{padding:10}}>
                <NavItem>
              <NavLink as={Link} to="#" active={activePeriod === 'Overdue'} onClick={this.fetchOverDueData}>
                  <span className="d-none d-sm-block">{t("Overdue")}</span>
                </NavLink>
              </NavItem>
              <NavItem>
              <NavLink as={Link} to="#" active={activePeriod === 'Today'} onClick={() => this.handlePeriodSelect('Today')}>
                  <span className="d-none d-sm-block">{t("Today")}</span>
                </NavLink>
              </NavItem>
              <NavItem>
              <NavLink as={Link} to="#" active={activePeriod === 'Tomorrow'} onClick={() => this.handlePeriodSelect('Tomorrow')}>
                  <span className="d-none d-sm-block">{t("Tomorrow")}</span>
                </NavLink>
              </NavItem>
              <NavItem>
              <NavLink as={Link} to="#" active={activePeriod === 'This Week'} onClick={() => this.handlePeriodSelect('This Week')}>
                  <span className="d-none d-sm-block">{t("This Week")}</span>
               </NavLink>
              </NavItem>
              <NavItem>
              <NavLink as={Link} to="#" active={activePeriod === 'Next Week'} onClick={() => this.handlePeriodSelect('Next Week')}>
                  <span className="d-none d-sm-block">{t("Next Week")}</span>
               </NavLink>
              </NavItem>
              {/* <NavItem>
              <NavLink as={Link} to="#" active={activePeriod.includes('/') ? true : false} onClick={() => this.handlePeriodSelect('Select Period')}>
                <span className="d-none d-sm-block">{activePeriod.includes('/') ? activePeriod : t("Select Period")}</span>
               </NavLink>
              </NavItem> */}
            </Nav>
           
            </Router>
                </Col>
              </Row>
              { showFlatpickr && (
                 <DateRangePicker
                 ranges={[{ startDate: this.state.dateRange[0], endDate: this.state.dateRange[1], key: 'selection' }]}
                 onChange={this.handleDateChange}
                 months={2}
                 direction="horizontal"
                showSelectionPreview={true}
                moveRangeOnFirstSelection={false}
                 minDate={new Date()}
               />
              )}
            
            </Card>

            <Row>
              <Col sm="12">
                <Card className="border-full mt-4">
                  {isSearch ? <CardHeader><h5>Search Result</h5></CardHeader> : '' }
                  <CardBody>
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead className="">
                          <tr>
                            <th className="align-middle" style={{width:10}}>#</th>
                            <th className="align-middle" style={{width:10}}>Done</th>
                            <th className="align-middle">Due Date</th>
                            <th className="align-middle">Type</th>
                            <th className="align-middle">Name</th>

                            <th className="align-middle">Email</th>
                            <th className="align-middle">Phone</th>
                          

                           
                          </tr>
                        </thead>
                        <tbody>
                        {map(activities, (activity, prokey) => (
                          <tr key={prokey}>
                           <td>{prokey+1}</td>
                            <td>
                                 {
                                      activity.activityStatus !== null && activity.activityType >= 1 && activity.activityType <= 5 ? (
                                        activity.activityStatus < 2 ? (
                                          <Link to="#"  onClick={() => this.handleChangeStatus(activity, 3)} className="status-check not-done">
                                            <i className="bx bxs-check-circle"></i>
                                          </Link>
                                        ) : (
                                          <Link to="#" onClick={() => this.handleChangeStatus(activity, 1)} className="status-check done">
                                            <i className="bx bxs-check-circle"></i>
                                          </Link>
                                        )
                                      ) : (
                                       
                                        <></>
                                      )
                                    }
                            </td>
                           <td>{activity.activityStartDate ? <Moment format="D MMM YY">{activity.activityStartDate}</Moment> : '' } </td>
                            <td>
                            {
                                activity.activityType === 5 ? (
                                  <Link to="#" onClick={() => this.toggleEdit(activity)}>
                                     <i className="bx bx-calendar"></i> {activity.title}
                                  </Link>
                                ) : activity.activityType === 1 ? (
                                  
                                 <span> <Link to="#" onClick={() => this.toggleEdit(activity)}><i className="bx bx-calendar"></i> {activity.title} </Link></span>
                                ) : activity.activityType === 2 ? (
                                  
                                  <span> <Link to="#" onClick={() => this.toggleEdit(activity)}><i className="bx bx-notepad"></i> {activity.title} </Link></span>
                                ) : activity.activityType === 3 ? (
                                  
                                  <span> <Link to="#" onClick={() => this.toggleEdit(activity)}><i className="bx bx-phone-call"></i> {activity.title} </Link></span>

                                ) : activity.activityType === 4 ? (
                                  
                                  <span> <Link to="#" onClick={() => this.toggleEdit(activity)}><i className="bx bx-mail-send"></i> {activity.title} </Link></span>
                                
                                ) : activity.activityType === 6 ? (
                                
                                  <span> <Link to="#" onClick={() => this.toggleSellerShowing(activity)}><i className="mdi mdi-sign-real-estate"></i> { activity.title} - Seller Showing </Link></span>
                                ) : activity.activityType === 7 ? (
                                
                                  <span><Link to="#" onClick={() => this.toggleBuyerShowing(activity)}><i className="mdi mdi-home-search-outline"></i>  {activity.title} - Buyer Showing </Link></span>
                                ) : activity.activityType === 8 ? (
                                
                                  <span><Link to="#" onClick={() => this.toggleOpenhouseShowing(activity)}><i className="dripicons-user-group"></i>  {activity.title} - Openhouse Showing </Link></span>
                                ) : activity.activityType === 9 ? (
                                
                                  <span><Link to="#" onClick={() => this.toggleEventShowing(activity)}><i className="dripicons-user-group"></i> {activity.title} </Link></span>
                                ) : (
                                  <>
                                    <i className="bx bx-right-arrow-alt"></i><span>{activity.title}</span>
                                    </>
                                  )
                              }
                            </td>
                           <td>
                            {(() => {
                              const { activityClientId, activityClientGuid, activityContactId, activityContactGuid, activityLeadId, activityLeadGuid, contactName } = activity;

                              let url = "#"; // Default
                              if (activityClientId > 0) {
                                url = `/clients/dashbord/${activityClientId}/${activityClientGuid}`;
                              } else if (activityContactId > 0) {
                                url = `/contact/contact-detail/${activityContactId}/${activityContactGuid}`;
                              } else if (activityLeadId > 0) {
                                url = `/contact/contact-detail/${activityLeadId}/${activityLeadGuid}`;
                              } else {
                                url = `#`;
                              }

                             return (
                                    <>
                                    <Link to={url}>
                                      {contactName} 
                                    </Link>
                                    { " " } {activity.projectName ? `(${activity.projectName})` : ""}
                                    </>
                                  );
                            })()}
                          </td>
                            <td>{activity.contactEmail} </td>
                            <td>{activity.contactPhone}</td>
                           
                           
                          </tr>
                       ))}
                        </tbody>
                      </table>


                    </div>
                  </CardBody>
                </Card>
              </Col>

            </Row>
          </Container>
        </div>
        <Offcanvas
          isOpen={this.state.isSearchFrm}
          direction="end"
          toggle={this.searchCanavas}
        >
          <OffcanvasHeader toggle={this.searchCanavas}>
            Search Activities
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                agentId: parseInt(localStorage.getItem('userId')),
                activityFromDate: '',
                activityToDate:'',
                refId:'',
                refTypeId: '',
               
              }}
              validationSchema={Yup.object().shape({
                activityFromDate: Yup.string().required("This is Required"),
                activityToDate: Yup.string().required("This is Required"),
                
              })}

              onSubmit={(values) => {
                const formattedData = {
                  activityTypeId:
                    values.activityTypeId && values.activityTypeId !== ""
                      ? [parseInt(values.activityTypeId)]
                      : [0], 
                  activityFromDate: values.activityFromDate
                    ? moment(values.activityFromDate).format('YYYY-MM-DD')
                    : null,
                  activityToDate: values.activityToDate
                    ? moment(values.activityToDate).format('YYYY-MM-DD')
                    : null,
                  refId: values.refId ? parseInt(values.refId) : 0,
                  refTypeId: values.refTypeId ? parseInt(values.refTypeId) : 0,
                  agentId: parseInt(localStorage.getItem("userId")),
                };
            
                this.searchSubmit(formattedData);
               
              }}
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >
                  <Row>
                  <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="fromDate">
                          {this.props.t("Search from Date")} <span className="requiredText">*</span>
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.activityFromDate && touched.activityFromDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          onChange={(value) => setFieldValue('activityFromDate', value[0])}
                          options={{
                            altInput: false,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                            minDate:'today'
                          }}
                        />
                         <ErrorMessage
                          name="activityFromDate"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="activityToDate">
                          {this.props.t("Search to Date")} <span className="requiredText">*</span>
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.activityToDate && touched.activityToDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          onChange={(value) => setFieldValue('activityToDate', value[0])}
                          options={{
                            altInput: false,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                            minDate:'today'
                          }}
                        />
                         <ErrorMessage
                          name="toDate"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="activityTypeId">
                          {this.props.t("Type of Activity")} <span className="requiredText"></span>
                        </Label>
                        <SafeField
                        name="activityTypeId"
                        as="select"
                        
                        onChange={e => {
                          handleChange(e);
                          
                        }}
                        className={
                            "form-control" +
                            (errors.activityTypeId && touched.activityTypeId
                            ? " is-invalid"
                            : "")
                        }
                        id="hrs"
                        >
                          
                         <option value="">All</option>
                         <option value="3">Calls</option>
                         <option value="1">Meetings</option>
                         <option value="2">To-do</option>
                         <option value="4">Emails</option>
                       
                         <option value="12">Messages</option>
                        </SafeField>
                           <ErrorMessage
                          name="activityTypeId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="refId">
                          {this.props.t("For")} <span className="requiredText"></span>
                        </Label>
                        <Select
                                       
                            name="refId"
                            isMulti={false}
                            onChange={(selectedOption) => {
                              setFieldValue("refId", selectedOption ? selectedOption.value : "");
                            }}
                            options={optionGroup1}
                            classNamePrefix="select2-selection"
                            isLoading={isLoading}
                        />
                           <ErrorMessage
                          name="refId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>

                    <div className="clearFix">
                      <SaveButton iconClass="bx bx-search">Search</SaveButton>
                      </div>
                  </Row>

                </Form>
              )}
            </Formik>

          </OffcanvasBody>
        </Offcanvas>
        <Offcanvas
          isOpen={this.state.isAddNew}
          direction="end"
          toggle={this.toggleAddNew}
          style={{width:800}}
        >
          <OffcanvasHeader toggle={this.toggleAddNew}>
            New Activity
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                agentId: parseInt(localStorage.getItem('userId')),
                title: 'Follow-up call',
                contactName: '',
                contactPhone: '',
                contactEmail: '',
                activityStartDate:'',
                startTime:'',
                endTime:'',
                activityType: '3',
                activityRefId:0,
                activityStatus: 1,
                activityDescription:'',
                activityLocationType:'3',
                activityLocation:'',
                activityLatitude:'',
                activityLongitude:'',
                isActive:true
              }}
              validationSchema={Yup.object().shape({
                activityType: Yup.string().required("This is Required"),
                title: Yup.string().required("This is Required"),
                contactName: Yup.string().required("This is Required"),
                activityStartDate:Yup.string().required("This is Required"),
               
                 contactEmail: Yup.string().when("activityType", (activityType, schema) => {
                    if (activityType === "1" || activityType === "4") {
                      return schema
                        .email("Invalid email format")
                        .required("This is Required");
                    }
                    return schema; 
                  }),
                  startTime: Yup.string().when("activityType", {
                    is: "1", // Meeting
                    then: Yup.string().required("This is Required"),
                  }),
                  endTime: Yup.string().when("activityType", {
                    is: "1", // Meeting
                    then: Yup.string().required("This is Required"),
                  }),
                  contactPhone: Yup.string().when("activityType", {
                    is: "3", // Call
                    then: Yup.string().required("This is Required"),
                  })
              })}

              onSubmit={this.handleSubmit}
             
            >
              {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                <Form
                  className="needs-validation"
                >
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="builderName">
                          {this.props.t("Type Of Activity")}
                        </Label>
                        <div className="clearfix"></div>
                        <div className="btn-group" role="group">
                          <SafeField type="radio" className="btn-check" 
                          onChange={(e) => {
                              handleChange(e); 
                              setFieldValue("title", "Follow-up call");
                            }}
                          name="activityType" id="btnradio4" value="3" autoComplete="off" />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio4">Call</label>

                          <SafeField type="radio" className="btn-check" 
                         onChange={(e) => {
                             handleChange(e); 
                              setFieldValue("title", "Follow-up meeting");
                            }}      
                          name="activityType" id="btnradio5" value="1" autoComplete="off" />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio5">Meeting</label>

                          <SafeField type="radio" className="btn-check" 
                           onChange={(e) => {
                             handleChange(e); 
                              setFieldValue("title", "Follow-up to-do");
                            }}   
                          name="activityType" id="btnradio6"  value="2" autoComplete="off" />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio6">Task</label>
                          <SafeField type="radio" className="btn-check" 
                            onChange={(e) => {
                             handleChange(e); 
                              setFieldValue("title", "Follow-up email");
                            }}
                          name="activityType" id="btnradio7"  value="4" autoComplete="off" />
                          <label className="btn btn-outline-secondary"  htmlFor="btnradio7">Email</label>
                          
                        </div>
                        <ErrorMessage
                          name="activityType"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="title">
                          {this.props.t("Subject")} <span className="requiredText">*</span>
                        </Label>
                        <SafeField
                              name="title"
                              onChange={handleChange}                            
                              type="text"
                              className={
                                "form-control" +
                                (errors.title && touched.title
                                  ? " is-invalid"
                                  : "")
                              }
                              id="title"
                              
                            /> 
                           <ErrorMessage
                          name="title"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="contactName">
                          {this.props.t("Name")} <span className="requiredText">*</span>
                        </Label>
                        <SafeField
                              name="contactName"
                              onChange={handleChange}                            
                              type="text"
                              className={
                                "form-control" +
                                (errors.contactName && touched.contactName
                                  ? " is-invalid"
                                  : "")
                              }
                              id="contactName"
                              
                            /> 
                           <ErrorMessage
                          name="contactName"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="contactEmail">
                         {this.props.t("Email")} {(values.activityType === '1' || values.activityType === '4') && ( <span className="requiredText">*</span> )}
                        </Label>
                        <SafeField
                              name="contactEmail"
                              onChange={handleChange}                            
                              type="text"
                              className={
                                "form-control" +
                                (errors.contactEmail && touched.contactEmail
                                  ? " is-invalid"
                                  : "")
                              }
                              id="contactEmail"
                              
                            /> 
                           <ErrorMessage
                          name="contactEmail"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>

                    <Col md="6">
                      <PhoneInputField
                        label="Phone"
                        name="contactPhone"
                        value={values.phone}
                        setFieldValue={setFieldValue}
                        error={errors.contactPhone}
                        touched={touched.contactPhone}
                        country="ca"
                        required={values.activityType === '3' ? true : false}
                      />
                  
                    </Col>
          
                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="activityStartDate">
                          {this.props.t("Date")} <span className="requiredText">*</span>
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.activityStartDate && touched.activityStartDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          onChange={(value) => setFieldValue('activityStartDate', value[0])}
                          options={{
                            altInput: false,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                            minDate: "today",
                          }}
                        />
                         <ErrorMessage
                          name="activityStartDate"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    { values.activityType === '1' && (
                    <>
                    <Col md="4">
                     
                       
                  <TimePicker
                  name="startTime"
                  label="Start Time *"
                  value={values.startTime}
                  onChange={(val) => setFieldValue("startTime", val)}
                  onBlur={() => setFieldTouched("startTime", true)}
                  minTime={null}
                  error={errors.startTime}
                  touched={touched.startTime}
                />

                {errors.startTime && touched.startTime && (
                  <div className="invalid-feedback">{errors.startTime}</div>
                )}
                     
                    </Col>

                    <Col md="4">
                    
                       
                          <TimePicker
                          name="endTime"
                          label="End Time *"
                          value={values.endTime}
                          onChange={(val) => setFieldValue("endTime", val)}
                          onBlur={() => setFieldTouched("endTime", true)}
                          minTime={values.startTime}
                          disabled={!values.startTime}
                          error={errors.endTime}
                          touched={touched.endTime}
                        />
                     
                    </Col>
                    </>
                    )}
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="activityDescription">
                          {this.props.t("Notes")}
                        </Label>
                        <SafeField
                          name="activityDescription"
                          onChange={handleChange}                            
                          type="text"
                          className={
                            "form-control" +
                            (errors.activityDescription && touched.activityDescription
                              ? " is-invalid"
                              : "")
                          }
                          id="activityDescription"
                          
                        /> 
                      </FormGroup>
                    </Col>
                    { values.activityType === '1' && (
                    <>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="notes">
                          {this.props.t("Location")}
                        </Label>
                        <div className="clearfix"></div>
                        <div className="btn-group" role="group">

                          <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio9" value="3" autoComplete="off" />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio9">In-person</label>
                          <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio10" value="1" autoComplete="off" />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio10">Online</label>
                        </div>

                      </FormGroup>
                    </Col>

                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="addressLine1">
                          {this.props.t("Location")}
                        </Label>
                        {values.activityLocationType === '3' ? (
                        <PlacesAutocomplete
                          value={values.activityLocation}
                          onChange={(value) => setFieldValue('activityLocation', value)}
                          onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                              <input
                                {...getInputProps({
                                  placeholder: 'Enter Address...',
                                  className: 'form-control',

                                })}
                              />
                              <div className="">
                                {loading ? <div>Loading...</div> : null}

                                {suggestions.map((suggestion, i) => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  const style = suggestion.active
                                    ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                    : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                  return (
                                    <div
                                      key={i}
                                      {...getSuggestionItemProps(suggestion, {
                                        style,
                                      })}
                                    >
                                      {suggestion.description}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>
                        ) : (
                          <SafeField
                          name="activityLocation"
                          onChange={handleChange}                            
                          type="text"
                          className={
                            "form-control" +
                            (errors.activityLocation && touched.activityLocation
                              ? " is-invalid"
                              : "")
                          }
                          id="activityLocation"
                          
                        /> 
                        )}
                      </FormGroup>
                    </Col>
                    </>
                    )}


                    {/* <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="notes">
                          {this.props.t("Assigned to")}
                        </Label>
                        <SafeField
                          name="activityLocation"
                          onChange={handleChange}                            
                          type="text"
                          className={
                            "form-control" +
                            (errors.activityLocation && touched.activityLocation
                              ? " is-invalid"
                              : "")
                          }
                          id="activityLocation"
                          
                        /> 
                      </FormGroup>
                    </Col> */}



                  </Row>

                  <Row>

                    <div className="clearFix">
                      <SaveButton>Save</SaveButton>
                      </div>
                  </Row>

                </Form>
              )}
            </Formik>

          </OffcanvasBody>
        </Offcanvas>

        <Offcanvas
                            isOpen={this.state.iseditOpen}
                            direction="end"
                            toggle={this.toggleEdit}
                            style={{width:800}}
                        >
                            <OffcanvasHeader toggle={this.toggleEdit}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                            <Formik
              enableReinitialize={true}
              initialValues={{
                        id: activity.id,
                        activityId: activity.activityId,
                        agentId: parseInt(activity.agentId),
                        title: activity.title,
                        contactName: activity.contactName,
                        contactPhone: activity.contactPhone,
                        contactEmail: activity.contactEmail,
                        activityStartDate: activity.activityStartDate,
                        startTime: activity.startTime,
                        endTime: activity.endTime,
                        activityDetails:activity.activityDetails,
                        activityType: String(activity.activityType),
                        activityStatus: activity.activityStatus,
                        activityRefId: activity.activityRefId,
                        activityDescription: activity.activityDescription,
                        activityLocationType: String(activity.activityLocationType),
                        activityLocation: activity.activityLocation,
                        activityLatitude: activity.activityLatitude,
                        activityLongitude: activity.activityLongitude,
                        isActive: activity.isActive,
                        markAsDone: (activity.activityStatus==3) ? true : false,
                        fromDate: activityFromDate,
                        toDate: activityToDate
              }}
              validationSchema={Yup.object().shape({
                activityType: Yup.string().required("This is Required"),
                title: Yup.string().required("This is Required"),
                contactName: Yup.string().required("This is Required"),
                activityStartDate: Yup.string().required("This is Required"),
                 contactEmail: Yup.string().when("activityType", (activityType, schema) => {
                    if (activityType === "1" || activityType === "4") {
                      return schema
                        .email("Invalid email format")
                        .required("This is Required");
                    }
                    return schema; 
                  }),
                  startTime: Yup.string().when("activityType", {
                    is: "1", // Meeting
                    then: Yup.string().required("This is Required"),
                  }),
                  endTime: Yup.string().when("activityType", {
                    is: "1", // Meeting
                    then: Yup.string().required("This is Required"),
                  }),
                  contactPhone: Yup.string().when("activityType", {
                    is: "3", // Call
                    then: Yup.string().required("This is Required"),
                  })
              })}

              onSubmit={values => {

                if (isEdit) {
                    const updateData = {
                      id: values.id,
                      activityId: values.activityId,
                      agentId: parseInt(values.agentId),
                      title: values.title,
                      contactName: values.contactName,
                      contactPhone: values.contactPhone,
                      contactEmail: values.contactEmail,
                      activityStartDate: moment(values.activityStartDate).format('YYYY-MM-DD'),
                      startTime: values.startTime,
                      endTime:values.endTime,
                      activityType: parseInt(values.activityType),
                      activityStatus: values.markAsDone ? 3 : parseInt(values.activityStatus),
                      activityRefId: parseInt(values.activityRefId),
                      activityDescription: values.activityDescription,
                       activityDetails:values.activityDetails,
                      activityLocationType: parseInt(values.activityLocationType),
                      activityLocation: values.activityLocation,
                      activityLatitude: values.activityLatitude ? values.activityLatitude : null,
                      activityLongitude: values.activityLongitude ? values.activityLongitude : null,
                      isActive: values.isActive,
                      fromDate: values.fromDate,
                      toDate: values.toDate
                    };
                    onUpdateMainActivity(updateData, (status) => {
                      if(status){
                         this.editToggle();
                      };
                    });
                } else {

                }
                
              }}
            >
              {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                <Form
                  className="needs-validation"
                >
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="builderName">
                          {this.props.t("Type Of Activity")}
                        </Label>
                        <div className="clearfix"></div>
                            <div className="btn-group" role="group">
                          <SafeField type="radio" className="btn-check" 
                          onChange={(e) => {
                              handleChange(e); 
                              //setFieldValue("title", "Follow-up call");
                            }}
                          name="activityType" id="btnradio4" value="3" autoComplete="off" />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio4">Call</label>

                          <SafeField type="radio" className="btn-check" 
                         onChange={(e) => {
                             handleChange(e); 
                              //setFieldValue("title", "Follow-up meeting");
                            }}      
                          name="activityType" id="btnradio5" value="1" autoComplete="off" />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio5">Meeting</label>

                          <SafeField type="radio" className="btn-check" 
                           onChange={(e) => {
                             handleChange(e); 
                              //setFieldValue("title", "Follow-up to-do");
                            }}   
                          name="activityType" id="btnradio6"  value="2" autoComplete="off" />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio6">Task</label>
                          <SafeField type="radio" className="btn-check" 
                            onChange={(e) => {
                             handleChange(e); 
                              //setFieldValue("title", "Follow-up email");
                            }}
                          name="activityType" id="btnradio7"  value="4" autoComplete="off" />
                          <label className="btn btn-outline-secondary"  htmlFor="btnradio7">Email</label>
                          
                        </div>
                        <ErrorMessage
                          name="activityType"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="title">
                          {this.props.t("Subject")}
                        </Label>
                        <SafeField
                              name="title"
                              onChange={handleChange}                            
                              type="text"
                              className={
                                "form-control" +
                                (errors.title && touched.title
                                  ? " is-invalid"
                                  : "")
                              }
                              id="title"
                              
                            /> 
                           <ErrorMessage
                          name="title"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="contactName">
                          {this.props.t("Name")}
                        </Label>
                        <SafeField
                              name="contactName"
                              onChange={handleChange}                            
                              type="text"
                              className={
                                "form-control" +
                                (errors.contactName && touched.contactName
                                  ? " is-invalid"
                                  : "")
                              }
                              id="contactName"
                              
                            /> 
                           <ErrorMessage
                          name="contactName"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-3">
                        <Label htmlFor="contactEmail">
                          {this.props.t("Email")} {(values.activityType === '1' || values.activityType === '4') && ( <span className="requiredText">*</span> )}
                        </Label>
                        <SafeField
                              name="contactEmail"
                              onChange={handleChange}                            
                              type="text"
                              className={
                                "form-control" +
                                (errors.contactEmail && touched.contactEmail
                                  ? " is-invalid"
                                  : "")
                              }
                              id="contactEmail"
                              
                            /> 
                           <ErrorMessage
                          name="contactEmail"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>

                    <Col md="6">
                       <PhoneInputField
                        label="Phone"
                        name="contactPhone"
                        value={values.contactPhone}
                        setFieldValue={setFieldValue}
                        error={errors.contactPhone}
                        touched={touched.contactPhone}
                        country="ca"
                        required={values.activityType === '3' ? true : false}
                      />
                      {/* <FormGroup className="mb-3">
                        <Label htmlFor="contactPhone">
                          {this.props.t("Phone")}
                        </Label>
                        <SafeField
                              name="contactPhone"
                              onChange={handleChange}                            
                              type="text"
                              className={
                                "form-control" +
                                (errors.contactPhone && touched.contactPhone
                                  ? " is-invalid"
                                  : "")
                              }
                              id="contactPhone"
                              
                            /> 
                           <ErrorMessage
                          name="contactPhone"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup> */}
                    </Col>
          
                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="activityStartDate">
                          {this.props.t("Date *")}
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.activityStartDate && touched.activityStartDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          value={values.activityStartDate}
                          onChange={(value) => setFieldValue('activityStartDate', value[0])}
                          options={{
                            altInput: false,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                            minDate: "today"
                          }}
                        />
                         <ErrorMessage
                          name="activityStartDate"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    { values.activityType === "1" && (
                    <>       
                    <Col md="4">
                      <TimePicker
                      name="startTime"
                      label="Start Time *"
                      value={values.startTime}
                      onChange={(val) => setFieldValue("startTime", val)}
                      onBlur={() => setFieldTouched("startTime", true)}
                      minTime={null}
                      error={errors.startTime}
                      touched={touched.startTime}
                    />

                    {errors.startTime && touched.startTime && (
                      <div className="invalid-feedback">{errors.startTime}</div>
                    )} 
                                                   
                    </Col>

                    <Col md="4">
                 <TimePicker
                name="endTime"
                label="End Time *"
                value={values.endTime}
                onChange={(val) => setFieldValue("endTime", val)}
                onBlur={() => setFieldTouched("endTime", true)}
                minTime={values.startTime}
                disabled={!values.startTime}
                error={errors.endTime}
                touched={touched.endTime}
              />
                    
                    </Col>
                        </>
                    )}
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="activityDetails">
                          {this.props.t("Notes")}
                        </Label>
                        <SafeField
                          name="activityDetails"
                          onChange={handleChange}                            
                          type="text"
                          className={
                            "form-control" +
                            (errors.activityDetails && touched.activityDetails
                              ? " is-invalid"
                              : "")
                          }
                          id="activityDetails"
                          
                        /> 
                      </FormGroup>
                    </Col>
                    { values.activityType === "1" && (
                    <>       
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="notes">
                          {this.props.t("Location")}
                        </Label>
                        <div className="clearfix"></div>
                        <div className="btn-group" role="group">

                          <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio9" value="3"
                             onChange={e => {
                              handleChange(e);
                              setFieldValue('activityLocation', '');
                              setFieldValue('activityLatitude', '');
                              setFieldValue('activityLongitude', '');
                            }}
                          
                          autoComplete="off" />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio9">In-person</label>
                          <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio10" value="1"
                          onChange={e => {
                            handleChange(e);
                            setFieldValue('activityLocation', '');
                            setFieldValue('activityLatitude', '');
                            setFieldValue('activityLongitude', '');
                          }}
                          autoComplete="off" />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio10">Online</label>
                        </div>

                      </FormGroup>
                    </Col>

                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="addressLine1">
                          {this.props.t("Location")}
                        </Label>
                        {values.activityLocationType === "3" ? (
                        <PlacesAutocomplete
                          value={values.activityLocation}
                          onChange={(value) => setFieldValue('activityLocation', value)}
                          onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                              <input
                                {...getInputProps({
                                  placeholder: 'Enter Address...',
                                  className: 'form-control',

                                })}
                              />
                              <div className="">
                                {loading ? <div>Loading...</div> : null}

                                {suggestions.map((suggestion, i) => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  const style = suggestion.active
                                    ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                    : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                  return (
                                    <div
                                      key={i}
                                      {...getSuggestionItemProps(suggestion, {
                                        style,
                                      })}
                                    >
                                      {suggestion.description}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>
                        ) : (
                          <SafeField
                          name="activityLocation"
                          onChange={handleChange}                            
                          type="text"
                          className={
                            "form-control" +
                            (errors.activityLocation && touched.activityLocation
                              ? " is-invalid"
                              : "")
                          }
                          id="activityLocation"
                          
                        /> 
                        )}
                      </FormGroup>
                    </Col>
                    </>
                    )}
                  </Row>
                  <Col md="12">
                      <FormGroup className="mb-3">
                       
                        <SafeField
                              name="markAsDone"
                              checked={values.markAsDone}
                              onChange={() => this.handleCheckboxChange(values, setFieldValue)}
                              type="checkbox"
                              id="markAsDone"
                              
                            /> {" "}
                             <Label htmlFor="markAsDone">
                          {this.props.t("Mark as done")}
                        </Label>
                           
                      </FormGroup>
                    </Col>
                  <Row>

                    <div className="clearFix">
                        {hasPermission("RealtorLeadsActivities", "Edit") && (
                          <>
                      <button type="submit" className="btn btn-primary w-md  mt20" name="addActivity" id="addActivity"> {this.props.t("Update")}</button>{" "}
                      </>
                        )}
                     
                          
                      <button type="button" className="btn btn-del-cancle w-md  mt20" onClick={this.toggleEdit}> {this.props.t("Cancel")}</button>{" "}
                     
                           {hasPermission("RealtorLeadsActivities", "Delete") && (
                      <button type="button" className="btn btn-del-danger w-md  mt20" onClick={() => this.onClickDelete(activity)}> {this.props.t("Delete")}</button>
                      )}
                      </div>
                  </Row>

                </Form>
              )}
            </Formik>
                            </OffcanvasBody>
        </Offcanvas>

        <Offcanvas
          isOpen={this.state.isSellerShowing}
          direction="end"
          toggle={this.toggleSellerShowing}
      >
          <OffcanvasHeader toggle={this.toggleSellerShowing}>
              Seller Showing
          </OffcanvasHeader>
          <OffcanvasBody>
          <div className="table-responsive">
          { sellershowingdetail ? (
          <Table className="table table-sm m-0">
                        
                        <tbody>
                          <tr>
                            <th scope="row">Listing</th>
                            <td>{sellershowingdetail.clientListing.mlsId}</td>

                          </tr>
                          <tr>
                          <th scope="row">Openhouse Date</th>
                            <td>{sellershowingdetail.showingDate ? <Moment format="D MMM YY">{sellershowingdetail.showingDate}</Moment> : '' }</td>      
                          </tr>
                          <tr>
                            <th scope="row">Start Time</th>
                            <td>{sellershowingdetail.startTime}</td>
                           
                          </tr>
                          <tr>
                          <th scope="row">End Time</th>
                          <td>{sellershowingdetail.endTime}</td>
                          
                          </tr>

                          <tr>
                          <th scope="row">Agent Name</th>
                          <td>{sellershowingdetail.agentName}</td>
                          </tr>
                          <tr>
                          <th scope="row">Agent Organization</th>
                          <td>{sellershowingdetail.agentOrganization}</td>
                          </tr>
                          <tr>
                          <th scope="row">Agent Contact</th>
                          <td>{sellershowingdetail.agentContact}</td>
                          </tr>
                          <tr>
                          <th scope="row">Agent Email</th>
                          <td>{sellershowingdetail.agentEmail}</td>
                          </tr>
                                               
                        </tbody>
                      </Table>
          ): null}
                    </div>    
          </OffcanvasBody>
          </Offcanvas>

          <Offcanvas
          isOpen={this.state.isBuyerShowing}
          direction="end"
          toggle={this.toggleBuyerShowing}
      >
          <OffcanvasHeader toggle={this.toggleBuyerShowing}>
              Buyer Showing
          </OffcanvasHeader>
          <OffcanvasBody>
          <div className="table-responsive">
          { buyershowingdetail ? (
          <Table className="table table-sm m-0">
                        
                        <tbody>
                          <tr>
                            <th scope="row">Listing</th>
                            <td>{buyershowingdetail.mlsId}</td>

                          </tr>
                          <tr>
                          <th scope="row">Listing Date</th>
                            <td>{buyershowingdetail.listingDate ? <Moment format="D MMM YY">{buyershowingdetail.listingDate}</Moment> : '' }</td>      
                          </tr>
                          <tr>
                            <th scope="row">Listing Status</th>
                            <td>{this.getStatus(buyershowingdetail.listingStatusId)}</td>
                           
                          </tr>
                          <tr>
                          <th scope="row">Listed Price</th>
                          <td>${buyershowingdetail.listedPrice}</td>
                          
                          </tr>

                          <tr>
                          <th scope="row">Listing Type</th>
                          <td>{buyershowingdetail.listingType ? localization["ListingType_" + buyershowingdetail.listingType] : ''}</td>
                          
                          </tr>

                          <tr>
                          <th scope="row">Bedroom</th>
                          <td>{buyershowingdetail.listingBedroom}</td>
                          </tr>
                          <tr>
                          <th scope="row">Bathroom</th>
                          <td>{buyershowingdetail.listingBathroom}</td>
                          </tr>
                          <tr>
                          <th scope="row">Parking</th>
                          <td>{buyershowingdetail.listingParking}</td>
                          </tr>
                          <tr>
                          <th scope="row">Address</th>
                          <td>{buyershowingdetail.listingAddress}</td>
                          </tr>
                          <tr>
                          <th scope="row">City</th>
                          <td>{buyershowingdetail.listingCity}</td>
                          </tr>
                          <tr>
                          <th scope="row">Notes</th>
                          <td>{buyershowingdetail.notes}</td>
                          </tr>
                                               
                        </tbody>
                      </Table>
          ): null}
                    </div>    
          </OffcanvasBody>
          </Offcanvas>

          <Offcanvas
          isOpen={this.state.isOpenhouseShowing}
          direction="end"
          toggle={this.toggleOpenhouseShowing}
      >
          <OffcanvasHeader toggle={this.toggleOpenhouseShowing}>
              Open House Showing
          </OffcanvasHeader>
          <OffcanvasBody>
          <div className="table-responsive">
          { openhouseshowingdetail ? (
          <Table className="table table-sm m-0">
                        
                        <tbody>
                          <tr>
                            <th scope="row">Listing</th>
                            <td>{openhouseshowingdetail.clientListing.mlsId}</td>

                          </tr>
                          <tr>
                          <th scope="row">Openhouse Date</th>
                            <td>{openhouseshowingdetail.openhouseDate ? <Moment format="D MMM YY">{openhouseshowingdetail.openhouseDate}</Moment> : '' }</td>      
                          </tr>
                          <tr>
                            <th scope="row">Start Time</th>
                            <td><Moment format="hh:mm A">{openhouseshowingdetail.startTime}</Moment></td>
                           
                          </tr>
                          <tr>
                          <th scope="row">End Time</th>
                          <td><Moment format="hh:mm A">{openhouseshowingdetail.endTime}</Moment></td>
                          
                          </tr>
                                               
                        </tbody>
                      </Table>
          ): null}
            
          </div>    
          </OffcanvasBody>
          </Offcanvas>

          <Offcanvas
          isOpen={this.state.isEventShowing}
          direction="end"
          toggle={this.toggleEventShowing}
      >
          <OffcanvasHeader toggle={this.toggleEventShowing}>
              Event Invites
          </OffcanvasHeader>
          <OffcanvasBody>
          <div className="table-responsive">
          { inviteDetail ? (
          <Table className="table table-sm m-0">
                        
                        <tbody>
                          <tr>
                            <th scope="row">Project Name</th>
                            <td>{inviteDetail.projectName}</td>

                          </tr>
                          <tr>
                            <th scope="row">Event Name</th>
                            <td>{inviteDetail.eventName}</td>

                          </tr>
                          <tr>
                          <th scope="row">Event Date</th>
                            <td>{inviteDetail.eventDate ? <Moment format="D MMM YY">{inviteDetail.eventDate}</Moment> : '' }</td>      
                          </tr>
                          <tr>
                            <th scope="row">Start Time</th>
                            <td><Moment format="hh:mm A" parse="HH:mm">{inviteDetail.eventStartTime}</Moment></td>
                           
                          </tr>
                          <tr>
                          <th scope="row">End Time</th>
                          <td><Moment format="hh:mm A" parse="HH:mm">{inviteDetail.eventEndTime}</Moment></td>
                          
                          </tr>

                          <tr>
                          <th scope="row">Location</th>
                          <td>{inviteDetail.address ? inviteDetail.address : inviteDetail.location }</td>
                          
                          </tr>

                         
                                               
                        </tbody>
                      </Table>
          ): null}
                    </div>    
          </OffcanvasBody>
          </Offcanvas>
      </React.Fragment >
    )

  }
}

Activity.propTypes = {
  t: PropTypes.any,
  loading:PropTypes.object,
  addNewActivity:PropTypes.func,
  postActivityFilter:PropTypes.func,
  postActivityOverviewFilter:PropTypes.func,
  activities:PropTypes.array,
  changeActivityStatus:PropTypes.func,
  onDeleteActivity:PropTypes.func,
  onUpdateMainActivity:PropTypes.func,
  onGetSellerShowingDetail:PropTypes.func,
  sellershowingdetail:PropTypes.object,
  onGetOpenhouseShowingDetail:PropTypes.func,
  openhouseshowingdetail:PropTypes.object,
  onGetBuyerShowingDetail:PropTypes.func,
  buyershowingdetail:PropTypes.object,
  onGetProjectInviteDetail:PropTypes.func,
  inviteDetail:PropTypes.object,
  searchActivityFilter:PropTypes.func

}
const mapStateToProps = ({ Activity, Project }) => (
  {
    loading: Activity.loading,
    activities:Activity.activities,
    sellershowingdetail:Activity.sellershowingdetail,
    openhouseshowingdetail:Activity.openhouseshowingdetail,
    buyershowingdetail:Activity.buyershowingdetail,
    inviteDetail:Project.inviteDetail
  })
const mapDispatchToProps = dispatch => ({

  addNewActivity: (data, callback) => dispatch(addNewActivity(data, callback)),
  postActivityFilter : (data) => dispatch(postActivityFilter(data)),
  postActivityOverviewFilter : (data) => dispatch(postActivityOverviewFilter(data)),
  searchActivityFilter: (data) => dispatch(searchActivityFilter(data)),
  changeActivityStatus : (data) => dispatch(changeActivityStatus(data)),
  onDeleteActivity:(id) =>  dispatch(deleteMainActivity(id)),
  onUpdateMainActivity:(data, callback) => dispatch(updateMainActivity(data, callback)),
  onGetSellerShowingDetail:(id) => dispatch(getSellerShowingDetail(id)),
  onGetOpenhouseShowingDetail:(id) => dispatch(getOpenhouseShowingDetail(id)),
  onGetBuyerShowingDetail:(id) => dispatch(getBuyerShowingDetail(id)),
  onGetProjectInviteDetail:(id) => dispatch(getProjectInviteDetail(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(Activity)))